let vowels = ['a', 'e', 'i', 'o', 'u', 'A', 'E', 'I', 'O', 'U'];
$(document).ready(function(){
  $('.species-lists .species-items .species-item.clickable').click(function(){
    if(!$(this).hasClass('active')){
      $('.species-lists .species-items .species-item.active').removeClass('active');
      $(this).addClass('active');
      let imagePath = $(this).attr('data-image');
      // Remove &width= param if present
      imagePath = imagePath.replace(/([&?])width=\d+(&)?/, (match, p1, p2) => p2 ? p1 : '');
      console.log(imagePath);
      
      let imageTitle = $(this).attr('data-title');
      $('.species-wrapper .bigger-image-wrapper .bigger-image-inner img').attr('src',imagePath);
      $('.species-wrapper .bigger-image-wrapper .bigger-image-inner img').attr('alt',imageTitle);
      $('.species-wrapper #species-title').html(imageTitle);

      var prefix_str = "a";
      if(vowels.indexOf(imageTitle[0]) > -1){
        prefix_str = "an";
      }
      $('.species-wrapper #species-desc-title').html(`${prefix_str} ${imageTitle.toLowerCase()}`);
      $(`.sticky-tab-wrapper a[href="#identify-section"]`).click();
    }
  });

  $(`.tab-container .sticky-tab-wrapper .sticky-tab-link`).click(function(){
    if(!$(this).hasClass('active')){
      $(`.tab-container .sticky-tab-wrapper .sticky-tab-link.active`).removeClass('active');
      $(this).addClass('active');

      const targetId = $(this).attr('href');
      const target = $(targetId);
      var excludeHeight = 0;
      if($(`.announcement-bar-section`).length){
        excludeHeight += $(`.announcement-bar-section`).height();
      }
      if($(`.section-header`).length){
        excludeHeight += $(`.section-header`).height();
      }
      if($(`.tutorial-tab-section`).length){
        excludeHeight += $(`.tutorial-tab-section`).height();        
      }
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - (excludeHeight - 100)
        }, 600);
      }
    }
  });

  // Update active tab on scroll
  $(window).on('scroll', function () {
    var scrollPosition = $(window).scrollTop();
    var windowHeight = $(window).height();
    var maxVisible = 0;
    var currentSectionId = '';

    $(`.species-section-wrapper`).each(function () {
      var sectionTop = $(this).offset().top;
      var sectionHeight = $(this).outerHeight();
      var visiblePart = Math.min(sectionTop + sectionHeight, scrollPosition + windowHeight) - Math.max(sectionTop, scrollPosition);

      if (visiblePart > maxVisible) {
        maxVisible = visiblePart;
        currentSectionId = $(this).find(`.section-scroll-id`).attr('id');
      }
    });

    if (currentSectionId) {
      $(`.tab-container .sticky-tab-wrapper .sticky-tab-link.active`).removeClass('active');
      $(`.tab-container .sticky-tab-wrapper .sticky-tab-link[href="#${currentSectionId}"]`).addClass('active');
    }
  });
});